export default __webpack_public_path__ + "static/media/adjunto.95105408.png";